module.exports = __webpack_public_path__ + "static/media/slr.00b07d3b.svg";